import OrderFullDecorator from "./OrderFullDecorator";
import ProductDecorator from "./ProductDecorator";
import ProductVariantDecorator from "./ProductVariantDecorator";
import ProductScheduleSlotDecorator from "./ProductScheduleSlotDecorator";

export default class ProductScheduleSlotFullDecorator extends ProductScheduleSlotDecorator {
  constructor({ product_id, product_variant_id, ...data }) {
    super({
      ...data,
      product: data.product && new ProductDecorator(data.product),
      product_variant: data.product_variant && new ProductVariantDecorator(data.product_variant),
      orders: data.orders && data.orders.map((x) => new OrderFullDecorator(x)),
    });
  }

  get product_id() {
    return this.product && this.product.id;
  }
  get product_variant_id() {
    return this.product_variant && this.product_variant.id;
  }
}



// WEBPACK FOOTER //
// ./src/lib/decorators/ProductScheduleSlotFullDecorator.js